module.exports = __webpack_public_path__ + "img/end-date-img.ea3f4e58.svg";